var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transfer',{attrs:{"data":_vm.courtList,"target-keys":_vm.targetKeys,"render-format":_vm.renderItem,"filterable":"","filter-method":_vm.filterMethod,"titles":_vm.titles},on:{"on-change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }